export default "__VITE_ASSET__e1acffd3__"